"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _clickAway = require("./click-away");
Object.keys(_clickAway).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _clickAway[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _clickAway[key];
    }
  });
});